var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalcony(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 12.0832V14.4998H9.66667V12.0832H12.0833ZM19.3333 14.4998V12.0832H16.9167V14.4998H19.3333ZM25.375 16.9165V26.5832H3.625V16.9165H4.83333V12.0832C4.83333 6.74234 9.15917 2.4165 14.5 2.4165C19.8408 2.4165 24.1667 6.74234 24.1667 12.0832V16.9165H25.375ZM8.45833 19.3332H6.04167V24.1665H8.45833V19.3332ZM13.2917 19.3332H10.875V24.1665H13.2917V19.3332ZM13.2917 4.92984C9.86 5.50984 7.25 8.49442 7.25 12.0832V16.9165H13.2917V4.92984ZM15.7083 16.9165H21.75V12.0832C21.75 8.49442 19.14 5.50984 15.7083 4.92984V16.9165ZM18.125 19.3332H15.7083V24.1665H18.125V19.3332ZM22.9583 19.3332H20.5417V24.1665H22.9583V19.3332Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcony);
export default __webpack_public_path__ + "static/media/balcony.50fdf33fc4685598c7603f82cca9a595.svg";
export { ForwardRef as ReactComponent };